import PropTypes from 'prop-types';

export interface ServerlessBackupOptions {
  serverlessContinuousBackupEnabled: boolean;
}

export const SERVERLESS_BACKUP_OPTIONS_SHAPE = {
  serverlessContinuousBackupEnabled: PropTypes.bool,
};

export function BuildServerlessBackupOptions(serverlessContinuousBackupEnabled: boolean): ServerlessBackupOptions {
  return {
    serverlessContinuousBackupEnabled: serverlessContinuousBackupEnabled,
  };
}
